<script setup lang="ts">
import I18n from '@/addons/i18n'
import { checkLinkClick } from '@/addons/functions'

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
    default: null,
  },
  sections: {
    type: Array,
    required: false,
    default: null,
  },
  link: {
    type: String,
    required: false,
    default: null,
  },
  qs: {
    type: String,
    required: false,
    default: null,
  },
})

const emits = defineEmits(['click', 'mouseenter', 'mouseleave'])

const onClick = async (e) => {
  if (props.link || props.qs) {
    await checkLinkClick(
      {
        attributes: props,
      },
      'boh', // TODO: what is context here?
    )
  } else {
    emits('click', e)
  }
}

const onMouseEnter = (e) => {
  emits('mouseenter', e)
}

const onMouseLeave = (e) => {
  emits('mouseleave', e)
}
</script>

<template>
  <div class="abs-core__navigation-item">
    <button
      class="abs-core__navigation-item__button"
      color="icon"
      @click="onClick"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
    >
      <fe-icon v-if="props.icon" :icon="props.icon" />
      <span v-if="props.label" class="fe-label">
        {{ I18n.global.t(props.label) }}
      </span>
      <fe-icon v-if="props.sections" class="fe-arrow" icon="chevron-right" />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.abs-core__navigation {
  &.openDrawer,
  &-second_level {
    .abs-core__navigation-item {
      &__button {
        justify-content: start;
        aspect-ratio: unset;
        width: 100%;

        .fe-label,
        .fe-arrow {
          display: flex;
        }
      }
    }
  }

  &-item {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover &__button,
    &.active &__button {
      background-color: rgba(var(--color-tertiary-light) / 0.35);
      color: rgb(var(--color-tertiary-dark));
    }

    &__button {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 1.23rem;
      aspect-ratio: 1 / 1;
      height: 40px;
      font-size: 1.23rem;
      font-weight: 400;
      font-family: Switzer, sans-serif;
      background: transparent;
      padding: 0 1rem;

      .fe-icon {
        margin-left: 0 !important;
        margin-right: 0 !important;
        font-size: 2rem;
        display: flex;
      }

      .fe-label,
      .fe-arrow {
        display: none;
      }

      .fe-arrow {
        margin-left: auto !important;
        font-size: 1rem;
      }

      /* style the “native” shadow part */
      &::part(native) {
        padding: 0;
        justify-content: flex-start !important;

        ::part(inner) {
          background-color: red !important;
        }
      }
    }
  }
}
</style>
